import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import formatTime from './../utils/formatTime';
import validation from './../utils/validation';
import classNames from './../utils/classNames';

import { financesWithdrawalFetch } from './../store/finances/actions';

import Modal from './Modal';
import Icon from './Icon';
import Radio from './Radio';

const AMOUNT_TYPE_ALL = 'all';
const AMOUNT_TYPE_CUSTOM = 'custom';

class FinancesModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            amountType: AMOUNT_TYPE_ALL,
            amountValue: '',
            showError: false
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.onInputClick = this.onInputClick.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onInputChange(event) {
        const { target } = event;
        this.setState(state => Object.assign({}, state, {
            [target.name]: target.value
        }))
    }

    onInputClick() {
        const { amountType } = this.state;
        if (amountType === AMOUNT_TYPE_CUSTOM) {
            return;
        }
        this.setState(state => Object.assign({}, state, {
            amountType: AMOUNT_TYPE_CUSTOM
        }));
    }

    getError() {
        const { amountType, amountValue } = this.state;
        const { minWithdrawal, available } = this.props;
        if (amountType === AMOUNT_TYPE_ALL) {
            return null;
        }
        if (!amountValue.length) {
            return 'Required value';
        }
        if (!validation.isCurrency(amountValue)) {
            return 'Invalid currency value';
        }
        if (!validation.isNotLess(amountValue, minWithdrawal / 100)) {
            return 'Cannot be less than ' + (minWithdrawal / 100).toFixed(2);
        }
        if (!validation.isNotOver(amountValue, available / 100)) {
            return 'Exceedes the allowable amount';
        }
        return null;
    }

    getWithdrawalAmount() {
        const { available } = this.props;
        const { amountType, amountValue } = this.state;

        const error = this.getError();
        if (error) {
            return 0;
        }

        if (amountType === AMOUNT_TYPE_ALL) {
            return available;
        }

        return amountValue * 100;
    }

    onSubmit() {
        const { isLoading, submitWithdrawal } = this.props;
        if (isLoading) {
            return;
        }
        if (this.getError()) {
            this.setState(state => Object.assign({}, state, {
                showError: true
            }));
            return;
        }
        const amount = this.getWithdrawalAmount();
        submitWithdrawal(amount);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isLoading && !this.props.isoading && !this.props.withdrawalErrorMessage) {
            this.props.toggleModal();
            this.setState(state => Object.assign({}, state, {
                amountType: AMOUNT_TYPE_ALL,
                amountValue: '',
                showError: false
            }));
        }
    }

    render() {
        const {
            isOpen,
            toggleModal,
            available,
            withdrawalTo,
            fee,
            nextWithdrawal,
            isLoading,
            withdrawalErrorMessage
        } = this.props;

        if (!isOpen) {
            return null;
        }

        const { amountType, amountValue, showError } = this.state;
        const error = showError ? this.getError() : null;
        const inputClassName = classNames('input-text', { 'is-error': error });

        return (
            <Modal onClose={toggleModal} wide>
                <h4 className="modal-info">Request withdrawal</h4>
                <div className="ballance-box row vertical">
                    <h2 className="col-5 title">Available ballance</h2>
                    <div className="col-2 ballance-sum">${(available / 100).toFixed(2)}</div>
                </div>
                <div className="withdrawal-box">
                    <div className="field-group row">
                        <div className="col-4">Withdraw method:</div>
                        <div className="col-4">{withdrawalTo}</div>
                    </div>
                    <div className="field-group row border">
                        <div className="col-4">Amount:</div>
                        <div className="col-4 field-val">
                            <Radio name="amountType" value="all" checked={amountType === AMOUNT_TYPE_ALL} onChange={this.onInputChange}>
                                <b>${(available / 100).toFixed(2)}</b> <span className="radio-label-note">(all available ballance)</span>
                            </Radio>
                            <Radio name="amountType" value="custom" checked={amountType === AMOUNT_TYPE_CUSTOM} onChange={this.onInputChange}>
                                <input
                                    type="text"
                                    maxLength="10"
                                    value={amountValue}
                                    name="amountValue"
                                    className={inputClassName}
                                    placeholder="Enter amount"
                                    onClick={this.onInputClick}
                                    onChange={this.onInputChange}
                                    readOnly={amountType !== AMOUNT_TYPE_CUSTOM}
                                />
                            </Radio>
                            {!!error &&
                                <div className="text-danger">{error}</div>
                            }
                            {!!withdrawalErrorMessage &&
                                <div className="text-danger">{withdrawalErrorMessage}</div>
                            }
                        </div>
                    </div>
                    <div className="field-group row">
                        <div className="col-4">Withdraw fee:</div>
                        <div className="col-4">${(fee / 100).toFixed(2)}</div>
                    </div>
                    <div className="field-group row">
                        <div className="col-4">Request before:</div>
                        <div className="col-4">{formatTime(nextWithdrawal, 'd')}, midnight</div>
                    </div>
                    <div className="field-group row">
                        <div className="col-4">Payment due date:</div>
                        <div className="col-4">{formatTime(moment(nextWithdrawal).add(10, 'days'), 'd')}, midnight</div>
                    </div>
                </div>
                <div className="summary-box">
                    <b>Summary:</b>
                    <p>${(this.getWithdrawalAmount() / 100).toFixed(2)} will be withdrawn to you {withdrawalTo}</p>
                    <p>on {formatTime(nextWithdrawal, 'd')}, midnight</p>
                </div>
                <div className="btn-group">
                    <button type="button" className="btn btn-light btn-sm" onClick={toggleModal}>Cancel</button>
                    <button type="button" className="btn btn-bright btn-sm" onClick={this.onSubmit} disabled={isLoading}>Proceed</button>
                </div>
                {isLoading &&
                    <div className="preloading preloading-box"><p>Loading</p></div>
                }
                <button className="btn btn-close" type="button" onClick={toggleModal}><Icon className="svg-icon" iconName="close" /></button>
            </Modal>
        );
    }
}

const mapStateToProps = state => {
    const finances = state.finances;
    const { available, pending, withdrawalTo, fee, nextWithdrawal, minWithdrawal, withdrawalErrorMessage } = finances;
    const isLoading = finances.isFetchingWithdrawal;
    return { available, pending, withdrawalTo, fee, nextWithdrawal, minWithdrawal, isLoading, withdrawalErrorMessage };
};

const mapDispatchToProps = dispatch => {
    return {
        submitWithdrawal: value => dispatch(financesWithdrawalFetch(value))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FinancesModal);


// WEBPACK FOOTER //
// ./src/components/FinancesModal.js